<style lang="scss" scoped>
$padding: 60px;
.text-banner {
    position: relative;
    width: 100%;
    height: auto;
    height: 400px;
    max-width: 2040px;
    margin: 0 auto;

    .content-wrapper {
        &:after {
            content: "";
            z-index: 1;
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 4px;
            background-image: linear-gradient(
                45deg,
                rgba(0, 0, 0, 0.5) 0%,
                rgba(0, 0, 0, 0) 100%
            );
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
    }

    .text-container {
        position: absolute;
        bottom: -32px;
        width: 100%;
        z-index: 2;

        .text {
            line-height: 1;
        }

        @media screen and (max-width: 1023.98px) {
            bottom: -19px !important;

            h1 {
                font-size: 120px !important;
            }
        }

        @media screen and (max-width: 767.98px) {
            bottom: -9px !important;

            h1 {
                font-size: 56px !important;
            }
        }
    }

    @media screen and (min-width: 1024px) {
        padding: $padding;
        height: 560px;
    }
}
.no-top-offset {
    .text-banner {
        padding-top: 0;
    }
}
</style>

<template>
    <div class="row">
        <div class="col-12">
            <div class="text-banner" :class="{'smaller': smaller}">
                <div class="content-wrapper h-100 position-relative">
                    <img :src="src" :alt="alt">
                    <div class="container position-relative">
                        <div class="text-container" id="herotextcontainer">
                            <h2 v-if="subText" class="text-white text font-weight-light mb-n12" v-html="subText"></h2>

                            <h1 v-if="scaleText == true" id="textbannertitle" class="text-white text" v-resize-text="{maxFontSize: '200px'}" v-html="text"></h1>
                            <h1 v-if="scaleText == false" id="textbannertitle" class="text-white text" v-html="text"></h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResizeText from 'vue-resize-text'

export default {
    name: "pagePart.text-banner-row",

    directives: {
        ResizeText
    },

    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
        subText: {
            type: String,
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
        smaller: {
            type: Boolean,
            required: false,
            default: false,
        },
        scaleText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: (vm) => ({
        oldWidth: document.documentElement.clientWidth,
    }),

    mounted() {
        var self = this;

        this.setBottomOffset();

        window.addEventListener('resize', () => { // only on width change because URL bar resizing on mobile         
            var newWidth = document.documentElement.clientWidth;
            if (newWidth != self.oldWidth) {
                self.setBottomOffset();
            }
            self.oldWidth = newWidth;
        });

        window.addEventListener('orientationchange', () => {
            this.setBottomOffset();
        })

    },

    methods: {
        setBottomOffset() {
            document.getElementById("herotextcontainer").style.bottom = `-${Math.round(document.getElementById("textbannertitle").clientHeight * 0.16)}px`;
        }
    }
}
</script>